import { schemaType } from "@features/seo/utils/types";

type JsonLdSchemaProps = {
  schema: schemaType;
};

/**
 * Component to inject the JSON-LD schema into the HTML.
 * For pages do not have a schema component in the sphtech/web2-seo-schema package.
 * @doc:
 *  - https://github.com/SPHTech/web2-seo-schema#available-components
 *  - https://sph.atlassian.net/wiki/spaces/PAPP/pages/3264938050/Guide+Implement+JSON-LD+schema+helpers+in+webcore+apps
 *
 * @param schema - The JSON-LD schema to inject.
 * @returns The React element to inject the JSON-LD schema into the HTML.
 */
const JsonLdSchema = ({ schema }: JsonLdSchemaProps): React.ReactElement => {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default JsonLdSchema;
